import 'vite/modulepreload-polyfill'
import {createRoot} from 'react-dom/client'
import App from './single-branch-map/App.tsx'

createRoot(document.getElementById('mwbm-single-branch-map')!).render(<App/>)
